
(function () {
  var sections = document.querySelectorAll('[data-section-type="accordions"]');

  sections.forEach(function (section) {
    var heads = section.querySelectorAll('[data-accordion-head]');

    heads.forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('[data-accordion-item]');
        var content = item.querySelector('[data-accordion-content]');
        var isActive = item.classList.contains('is-active');

        var allItems = section.querySelectorAll('[data-accordion-item]');
        allItems.forEach(function (otherItem) {
          var otherContent = otherItem.querySelector('[data-accordion-content]');
          otherItem.classList.remove('is-active');
          otherContent.style.maxHeight = null;
        });

        if (!isActive) {
          item.classList.add('is-active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });
})();